// src/slices/printRequestsSlice.js

import { createSlice } from '@reduxjs/toolkit';

const printRequestsSlice = createSlice({
    name: 'printRequests',
    initialState: {
        list: [], // Store print requests in an array
    },
    reducers: {
        setRequests(state, action) {
            // Replace the list with a new array of requests
            state.list = action.payload;
        },
        addRequest(state, action) {
            const existingIndex = state.list.findIndex(request => request.id === action.payload.id);
            if (existingIndex !== -1) {
                // If request with the same ID exists, update it
                state.list[existingIndex] = action.payload;
            } else {
                // Otherwise, add it as a new request
                state.list.push(action.payload);
            }
        },
        removeRequest(state, action) {
            // Remove a request by ID
            state.list = state.list.filter(request => request.id !== action.payload);
        },
        clearRequests(state) {
            // Clear all requests from the list
            state.list = [];
        }
    },
});

export const { setRequests, addRequest, removeRequest, clearRequests } = printRequestsSlice.actions;

export default printRequestsSlice.reducer;
